import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgSunGlyphSecondary from './svgs/SunGlyphSecondary.js';
import SvgSunGlyph from './svgs/SunGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var sunGlyph = (props => useIcon(SvgSunGlyph, SvgSunGlyphSecondary, props));

export { sunGlyph as default };
